import * as React from "react";
import Box from "@mui/material/Box";
import {Link} from "react-router-dom";
import {Link as MuiLink} from "@mui/material";
import Typography from "@mui/material/Typography";

export default () => (
    <Box sx={{textAlign: 'center', mt: 10}}>
        <Box sx={{fontSize: {md: '10rem', xs: '5rem'}, opacity: .35}}>
            404
        </Box>
        <Typography variant="h6" sx={{mb: 2}}>
            How'd you end up here?
        </Typography>
        <MuiLink component={Link} to='/'
                 style={{fontSize: '1rem', 'textDecoration': 'none'}}>
            Take me home
        </MuiLink>
    </Box>

)